import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import { getUseDiscountsService } from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";

export const useDiscountAdminContext = createContext({
  users: [],
  setUsers: () => {},
  user: {},
  setUser: () => {},
  search: "",
  setSearch: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetUseDiscounts: () => {},
});

const UseDiscountAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [users, setUsers] = useState([]);
  const [user, setUser] = useState({});
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);

  // Details Use Discount Modal Operations
  const handleShowDetailsModal = (value) => {
    setIsShowDetailsModal(true);
    setUser(value);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setUser({});
  };

  // Handle Get Use Discounts Method
  const handleGetUseDiscounts = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      page: (isSearch ? 1 : pageNumber) - 1,
      search,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getUseDiscountsService(objData);
      if (status === 200) {
        setUsers(data.list);
        setTotalCount(data.total);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <useDiscountAdminContext.Provider
      value={{
        users,
        setUsers,
        user,
        setUser,
        search,
        setSearch,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        isShowDetailsModal,
        setIsShowDetailsModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleGetUseDiscounts,
      }}
    >
      {children}
    </useDiscountAdminContext.Provider>
  );
};

export default UseDiscountAdminContext;
